(ns dashboard.components.datepicker
  (:require
   [reagent.core :as reagent]
   [re-frame.core :as re-frame]
   [headlessui-reagent.core :as ui]
   [dashboard.utils :refer [cs listen]]
   [dashboard.subs :as subs]
   ["@heroicons/react/solid" :refer [CalendarIcon]]
   ["date-fns" :refer
    [format setISODay setMonth setYear startOfMonth startOfWeek getMonth getYear
     getISOWeek addDays isAfter isSameDay subMonths addMonths]]))

(defn datepicker
  [{:keys [selected-date label on-change class small? disabled?]
    :or {on-change identity
         small? false
         disabled? false}}]
  (let [dummy-base-date (js/Date.)
        month (getMonth selected-date)
        year (getYear selected-date)
        m (reagent/atom (setMonth (setYear dummy-base-date year) month))]
    (fn [{:keys [selected-date]}]
      (let [month-start (startOfMonth @m)
            first-week-day (startOfWeek month-start)]
        [:div.inline-block
         (when (some? label)
           [:label.label.mb-1
            label])
         [ui/popover
          [ui/popover-button
           {:class (cs "relative w-full border rounded-md pl-3 pr-10 text-left cursor-default focus:outline-none focus:ring-1 focus:ring-primary-500 focus:border-primary-500 focus:text-gray-700 text-sm py-2"
                       (if disabled? "bg-gray-50 text-gray-300 border-gray-200" "bg-white text-gray-700 border-gray-300")
                       (when (some? class) class))}
           [:span.flex.items-center
            [:span.block
             (when (some? selected-date)
               (format selected-date "PP" #js {:locale (listen ::subs/date-fns-locale)}))]]
           [:span.absolute.inset-y-0.right-0.flex.items-center.pr-2.pointer-events-none
            [:> CalendarIcon
             {:class "h-5 w-5"
              :aria-hidden true}]]]
          [ui/transition
           {:class "relative z-40"
            :enter "transition ease-out duration-200"
            :enter-from "transform opacity-0 scale-95"
            :enter-to "transform opacity-100 scale-100"
            :leave "transition ease-in duration-75"
            :leave-from "transform opacity-100 scale-100"
            :leave-to "transform opacity-0 scale-95"}
           [ui/popover-panel
            {:class "absolute origin-top-right mt-2 w-72 rounded-md shadow-lg py-1 bg-white ring-1 ring-black ring-opacity-5 focus:outline-none p-4 z-40"}
            [:div.pt-2
             [:div.flex.justify-between.items-center.mb-2
              (if (= (listen ::subs/locale) :ja)
                [:div
                 [:span.text-lg.text-gray-600.font-normal
                  (str year "年") ]
                 [:span.text-lg.font-bold.text-gray-800.ml-1
                  (format @m "MMMM" #js {:locale (listen ::subs/date-fns-locale)})]]
                [:div
                 [:span.text-lg.font-bold.text-gray-800
                  (format @m "MMMM" #js {:locale (listen ::subs/date-fns-locale)})]
                 [:span.ml-1.text-lg.text-gray-600.font-normal
                  year]])
              [:div
               [:button
                {:type "button"
                 :on-click #(reset! m (subMonths @m 1))}
                [:svg.h-6.w-6.text-gray-500.inline-flex
                 {:fill "none"
                  :viewBox "0 0 24 24"
                  :stroke "currentColor"}
                 [:path
                  {:d "M15 19l-7-7 7-7"
                   :stroke-linecap "round"
                   :stroke-linejoin "round"
                   :stroke-width "2"}]]]
               [:button
                {:type "button"
                 :on-click #(reset! m (addMonths @m 1))}
                [:svg.h-6.w-6.text-gray-500.inline-flex
                 {:fill "none"
                  :viewBox "0 0 24 24"
                  :stroke "currentColor"}
                 [:path
                  {:d "M9 5l7 7-7 7"
                   :stroke-linecap "round"
                   :stroke-linejoin "round"
                   :stroke-width "2"}]]]]]
             ;; Header with Day of the week
             [:div.flex.flex-wrap.mb-3.-mx-1
              (doall
               (for [dow (range 7)]
                 ^{:key dow}
                 [:div.px-1.flex-1
                  [:div.text-gray-800.font-medium.text-center.text-xs
                   (format (setISODay @m dow) "EEEEEE"
                           #js {:locale (listen ::subs/date-fns-locale)})]]))]
             [:div.mb-3.-mx-1
              (doall
               (for [row (range 6)
                     :let [week-number (getISOWeek (addDays first-week-day (* row 7)))
                           start-day-of-week (addDays first-week-day (* row 7))
                           end-day-of-week (addDays start-day-of-week 6)
                           week-in-this-month? (or
                                                (= (getMonth start-day-of-week) (getMonth @m))
                                                (= (getMonth end-day-of-week) (getMonth @m)))]]
                 ^{:key week-number}
                 [:div.px-1.flex.flex-row
                  ;; text-center border p-1 border-transparent text-sm
                  (when week-in-this-month?
                    (doall
                     (for [col (range 7)
                           :let [date (addDays first-week-day (+ (* row 7) col))
                                 formatted-date (format date "yyyy-MM-dd")
                                 is-outside-month? (not= (getMonth date) (getMonth @m))
                                 is-future? (isAfter date (js/Date.))
                                 is-selected? (isSameDay selected-date date)]]
                       ^{:key formatted-date}
                       [:div.cursor-pointer.text-sm.leading-none.leading-loose.transition.ease-in-out.duration-100.flex-1
                        {:class (cs "rounded-full hover:bg-primary-500 hover:text-white"
                                    (when (some? class) class)
                                    (when is-outside-month? "text-gray-200")
                                    (when is-future? "text-gray-500")
                                    (when is-selected? "bg-primary-700 text-white"))
                         :on-click #(on-change date)}
                        [:div.text-center
                         (format date "d")]])))]))]]]]]]))))
